export default {"src":"/_next/static/media/close-white.4069326d.svg","height":24,"width":24};